@if (isLoadingResults) {
  <div class="example-loading-shade">
      <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div cdkDrag class="popup_main_div add_edit_allowance" cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>{{ dialogTitle }}</span>
    <mat-slide-toggle (change)="ToggleForUpadte()">Show Template Fields</mat-slide-toggle>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form [formGroup]="AllowanceForm" fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.SETTLEMENTTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SETTLEMENTTYPE),
            }"
          >
            <mat-label>Allowance type</mat-label>
            <mat-select
              (selectionChange)="allowanceChange($event.value)"
              formControlName="SETTLEMENTTYPE"
            >
              @for (val of AlowanceType; track val) {
                <mat-option [value]="val.ALLOWANCEDESC">
                  {{ val.ALLOWANCEDESC }}
                </mat-option>
              }
            </mat-select>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.SETTLEMENTTYPE?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.SETTLEMENTTYPE?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.ALTERNATEDESCRIPTION),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.ALTERNATEDESCRIPTION
              ),
            }"
          >
            <mat-label>Alternate Description</mat-label>
            <input
              matInput
              formControlName="ALTERNATEDESCRIPTION"
              matTooltip="{{ toolTipList?.ALTERNATEDESCRIPTION?.HOVER || '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(toolTipList?.ALTERNATEDESCRIPTION?.COPYVALUE)
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  [value]="$safeNavigationMigration(toolTipList?.ALTERNATEDESCRIPTION?.COPYVALUE)"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          @if (selectedAllowance?.SHOWAMOUNTPERUNIT && showAmountInput) {
            <mat-form-field
              appearance="outline"
              fxFlex="100"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.AMOUNTPERUNIT),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AMOUNTPERUNIT),
              }"
            >
              <mat-label>{{ selectedAllowance?.AMOUNTPERUNITDESC }}</mat-label>
              <!-- <input style="text-align: right;" (click)="$event.target.select()" matInput formControlName="AMOUNTPERUNIT" (blur)="amountChange($event, 'AMOUNTPERUNIT')" (focusout)="CalcSettlementAllowance()"  matTooltip="{{(toolTipList)?toolTipList.SHOWAMOUNTPERUNIT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion" appNumericdirective> -->
              <!-- (change)="amountChange($event, 'AMOUNTPERUNIT')" -->
              <!-- [value]="AllowanceForm.get('AMOUNTPERUNIT').value | number: '1.4-4'" -->
              <!-- type="float" (blur)="amountChange($event, 'AMOUNTPERUNIT')" -->
              <input
                style="text-align: right"
                /* [value]="
                  $safeNavigationMigration(AllowanceForm.get('AMOUNTPERUNIT')?.value)
                    | number: amountDecimalFormat
                " */
                type="text"
                [mask]="amountMaskPattern"
                thousandSeparator=","
                decimalMarker="."
                [leadZero]="true"
                matInput
                formControlName="AMOUNTPERUNIT"
                (focusout)="CalcSettlementAllowance()"
                matTooltip="{{ toolTipList ? toolTipList?.SHOWAMOUNTPERUNIT?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList
                        ? $safeNavigationMigration(toolTipList?.AMOUNTPERUNIT?.COPYVALUE)
                        : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.AMOUNTPERUNIT?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          @if (selectedAllowance?.SHOWCOUNT) {
            <mat-form-field
              appearance="outline"
              fxFlex="100"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.COUNT),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COUNT),
              }"
            >
              <mat-label>Number of Allowances</mat-label>
              <input
                matInput
                type="number"
                formControlName="COUNT"
                (focusout)="CalcSettlementAllowance()"
                matTooltip="{{ toolTipList ? toolTipList?.SHOWCOUNT?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList ? $safeNavigationMigration(toolTipList?.SHOWCOUNT?.COPYVALUE) : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.SHOWCOUNT?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          @if (selectedAllowance?.SHOWUNITSIZE) {
            <mat-form-field
              appearance="outline"
              fxFlex="100"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.UNITSIZE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.UNITSIZE),
              }"
            >
              <mat-label>{{ selectedAllowance?.UNITSIZEDESC }}</mat-label>
              <!-- (change)="amountChange($event, 'UNITSIZE')" -->
              <!-- [value]="AllowanceForm.get('UNITSIZE').value | number: '1.4-4'" -->
              <!-- (blur)="amountChange($event, 'UNITSIZE')" -->
              <input
                matInput
                style="text-align: right"
                [value]="AllowanceForm.get('UNITSIZE').value | number: '1.4-4'"
                type="text"
                mask="separator.4"
                thousandSeparator=","
                decimalMarker="."
                [leadZero]="true"
                formControlName="UNITSIZE"
                (focusout)="CalcSettlementAllowance()"
                matTooltip="{{ toolTipList ? toolTipList.SHOWUNITSIZE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList
                        ? $safeNavigationMigration(toolTipList?.SHOWUNITSIZE?.COPYVALUE)
                        : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.SHOWUNITSIZE?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          @if (selectedAllowance?.SHOWSTATUS) {
            <mat-form-field
              appearance="outline"
              fxFlex="100"
              class="pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.STATUS),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STATUS),
              }"
            >
              <mat-label>{{ selectedAllowance?.STATUSDESC }}</mat-label>
              <mat-select formControlName="STATUS" (selectionChange)="CalcSettlementAllowance()">
                @for (val of StatusOption; track val) {
                  <mat-option value="{{ val }}">{{ val }}</mat-option>
                }
              </mat-select>
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList ? $safeNavigationMigration(toolTipList?.STATUS?.COPYVALUE) : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.STATUS?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          @if (selectedAllowance?.SHOWDATEFROM) {
            <mat-form-field
              class="example"
              fxFlex="100"
              class="pr-1"
              appearance="outline"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEFROM),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEFROM),
              }"
            >
              <mat-label>Date Range List</mat-label>
              <mat-select
                formControlName="DATERANGE"
                #values
                name="DATERANGE"
                (selectionChange)="hideshowdatepicker($event.value)"
              >
                <mat-option value="Last Financial Year">Last Financial Year</mat-option>
                <mat-option value="Current Financial Year">Current Financial Year</mat-option>
                <mat-option value="First Half of Current Financial Year">
                  First Half of Current Financial Year
                </mat-option>
                <mat-option value="Second Half of Current Financial Year">
                  Second Half of Current Financial Year
                </mat-option>
                <mat-option value="Last Calendar Year">Last Calendar Year</mat-option>
                <mat-option value="This Calendar Year">This Calendar Year</mat-option>
                <mat-option value="First Half of Current Calendar Year" selected="">
                  First Half of Current Calendar Year
                </mat-option>
                <mat-option value="Second Half of Current Calendar Year">
                  Second Half of Current Calendar Year
                </mat-option>
                <mat-option value="1st Quarter (1 Jan – 31 March)">
                  1st Quarter (1 Jan – 31 March)
                </mat-option>
                <mat-option value="2nd Quarter ( 1 April – 30 June)">
                  2nd Quarter ( 1 April – 30 June)
                </mat-option>
                <mat-option value="3rd Quarter  (1 July – 30 Sept)">
                  3rd Quarter (1 July – 30 Sept)
                </mat-option>
                <mat-option value="4th Quarter  (1 Oct – 31 Dec)">
                  4th Quarter (1 Oct – 31 Dec)
                </mat-option>
                <mat-option value="Date Range">Date Range</mat-option>
              </mat-select>
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList
                        ? $safeNavigationMigration(toolTipList?.SHOWDATEFROM?.COPYVALUE)
                        : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.SHOWDATEFROM?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          @if (selectedAllowance?.SHOWDATEFROM) {
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEFROM),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEFROM),
              }"
              appearance="outline"
              class="example"
              fxFlex="50"
              class="pr-1"
            >
              <mat-label>Date From</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="DATEFROMTEXT"
                (dateChange)="choosedFromDate('change', $event)"
                [max]="AllowanceForm.get('TODATETEXT')?.value"
                [errorStateMatcher]="dateRangeMatcher"
                matTooltip="{{ toolTipList ? toolTipList.DATEFROM?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList ? $safeNavigationMigration(toolTipList?.DATEFROM?.COPYVALUE) : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.DATEFROM?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
          @if (selectedAllowance?.SHOWTODATE) {
            <mat-form-field
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.TODATE),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TODATE),
              }"
              appearance="outline"
              class="example"
              fxFlex="50"
              class="pr-1"
            >
              <mat-label>Date To</mat-label>
              <input
                matInput
                [matDatepicker]="picker2"
                formControlName="TODATETEXT"
                (dateChange)="choosedToDate('change', $event)"
                [min]="AllowanceForm.get('DATEFROMTEXT')?.value"
                [errorStateMatcher]="dateRangeMatcher"
                matTooltip="{{ toolTipList ? toolTipList.TODATE?.HOVER : '' }}"
                [matTooltipPosition]="toolTipPostion"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              @if (AllowanceForm.hasError('dateRange')) {
                <mat-error>From Date cannot be later than To Date</mat-error>
              }
              @if (testBool && toolTipList) {
                <div
                  class="tooltip-wrap"
                  (click)="
                    tooltipService.copyTooltipText(
                      toolTipList ? $safeNavigationMigration(toolTipList?.TODATE?.COPYVALUE) : ''
                    )
                  "
                >
                  <input
                    id="myInput"
                    readonly
                    disabled
                    value="{{ toolTipList?.TODATE?.COPYVALUE }}"
                  />
                  <mat-icon>file_copy</mat-icon>
                </div>
              }
            </mat-form-field>
          }
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.COMMENT,'has-warning':errorWarningData.Warning?.COMMENT}">
          <mat-label>COMMENT</mat-label>
          <textarea matInput formControlName="COMMENT"  matTooltip="{{(toolTipList)?toolTipList?.COMMENT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"></textarea>
          <div  *ngIf="testBool && toolTipList" class="tooltip-wrap"  (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.COMMENT?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.COMMENT?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>

        </mat-form-field> -->

          <mat-form-field
            appearance="outline"
            fxFlex="100"
            class="full-width pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.COMMENT),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COMMENT),
            }"
          >
            <mat-label>Comment</mat-label>

            <textarea
              matInput
              formControlName="COMMENT"
              rows="4"
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              cdkAutosizeMaxRows="10"
              (keydown.enter)="$event.stopImmediatePropagation()"
              [matTooltip]="
                toolTipList ? $safeNavigationMigration(toolTipList?.COMMENT?.HOVER) : ''
              "
              [matTooltipPosition]="toolTipPostion"
            ></textarea>
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList ? $safeNavigationMigration(toolTipList?.COMMENT?.COPYVALUE) : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.COMMENT?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYABLEBYPURCHASER),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYABLEBYPURCHASER),
            }"
            class="example gray_out_for_poup readonly_apply pr-1"
            appearance="outline"
            fxFlex="33.33"
          >
            <mat-label>Payable By Purchaser</mat-label>
            <input
              formControlName="PAYABLEBYPURCHASER"
              matInput
              readonly
              currencyMask
              matTooltip="{{ toolTipList ? toolTipList?.PAYABLEBYPURCHASER?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.PAYABLEBYPURCHASER?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.PAYABLEBYPURCHASER?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <mat-form-field
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYABLEBYVENDER),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYABLEBYVENDER),
            }"
            class="example gray_out_for_poup readonly_apply pr-1"
            appearance="outline"
            fxFlex="33.33"
          >
            <mat-label>Payable By Vendor</mat-label>
            <input
              formControlName="PAYABLEBYVENDER"
              matInput
              readonly
              currencyMask
              matTooltip="{{ toolTipList ? toolTipList?.PAYABLEBYVENDER?.HOVER : '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    toolTipList
                      ? $safeNavigationMigration(toolTipList?.PAYABLEBYVENDER?.COPYVALUE)
                      : ''
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  value="{{ toolTipList?.PAYABLEBYVENDER?.COPYVALUE }}"
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
          <!-- <mat-form-field
                        class="example"
                        fxFlex="33.33"
                        class="pr-1"
                        appearance="outline"
                        [ngClass]="{
                            'has-error': $safeNavigationMigration(
                                errorWarningData.Error?.APPLICABLETOWHO
                            ),
                            'has-warning': $safeNavigationMigration(
                                errorWarningData.Warning?.APPLICABLETOWHO
                            ),
                        }"
                    >
                        <mat-label>Applicable to who?</mat-label>
                        <mat-select
                            formControlName="APPLICABLETOWHO"
                            name="APPLICABLETOWHO"
                        >
                            <mat-option value="All">All</mat-option>
                            <mat-option value="Vendor Only">Vendor Only</mat-option>
                            <mat-option value="Purchaser Only">Purchaser Only</mat-option>
                            <mat-option value="Hidden">Hidden</mat-option>
                        </mat-select>
                        @if (testBool && toolTipList) {
                            <div
                                class="tooltip-wrap"
                                (click)="
                                    tooltipService.copyTooltipText(
                                        toolTipList
                                            ? $safeNavigationMigration(
                                                  toolTipList?.APPLICABLETOWHO?.COPYVALUE
                                              )
                                            : ''
                                    )
                                "
                            >
                                <input
                                    id="myInput"
                                    readonly
                                    disabled
                                    value="{{ toolTipList?.APPLICABLETOWHO?.COPYVALUE }}"
                                />
                                <mat-icon>file_copy</mat-icon>
                            </div>
                        }
                    </mat-form-field> -->
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="34"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(
                errorWarningData.Error?.ADDITIONALFEEDESCRIPTION
              ),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.ADDITIONALFEEDESCRIPTION
              ),
            }"
          >
            <mat-label>Additional Fee Desc</mat-label>
            <input
              matInput
              formControlName="ADDITIONALFEEDESCRIPTION"
              matTooltip="{{ toolTipList?.ADDITIONALFEEDESCRIPTION?.HOVER || '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(toolTipList?.ADDITIONALFEEDESCRIPTION?.COPYVALUE)
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  [value]="
                    $safeNavigationMigration(toolTipList?.ADDITIONALFEEDESCRIPTION?.COPYVALUE)
                  "
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            fxFlex="33.33"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(
                errorWarningData.Error?.ADDITIONALFEEPAYABLEBYPURCHASER
              ),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.ADDITIONALFEEPAYABLEBYPURCHASER
              ),
            }"
          >
            <mat-label>Additional Purchaser Fee</mat-label>
            <input
              class="right-align-input"
              matInput
              formControlName="ADDITIONALFEEPAYABLEBYPURCHASER"
              mask="separator.2"
              thousandSeparator=","
              decimalMarker="."
              [leadZero]="true"
              matTooltip="{{ toolTipList?.ADDITIONALFEEPAYABLEBYPURCHASER?.HOVER || '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(
                      toolTipList?.ADDITIONALFEEPAYABLEBYPURCHASER?.COPYVALUE
                    )
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  [value]="
                    $safeNavigationMigration(
                      toolTipList?.ADDITIONALFEEPAYABLEBYPURCHASER?.COPYVALUE
                    )
                  "
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            fxFlex="33.33"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(
                errorWarningData.Error?.ADDITIONALFEEPAYABLEBYVENDOR
              ),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.ADDITIONALFEEPAYABLEBYVENDOR
              ),
            }"
          >
            <mat-label>Additional Vendor Fee</mat-label>
            <input
              class="right-align-input"
              matInput
              formControlName="ADDITIONALFEEPAYABLEBYVENDOR"
              mask="separator.2"
              thousandSeparator=","
              decimalMarker="."
              [leadZero]="true"
              matTooltip="{{ toolTipList?.ADDITIONALFEEPAYABLEBYVENDOR?.HOVER || '' }}"
              [matTooltipPosition]="toolTipPostion"
            />
            @if (testBool && toolTipList) {
              <div
                class="tooltip-wrap"
                (click)="
                  tooltipService.copyTooltipText(
                    $safeNavigationMigration(toolTipList?.ADDITIONALFEEPAYABLEBYVENDOR?.COPYVALUE)
                  )
                "
              >
                <input
                  id="myInput"
                  readonly
                  disabled
                  [value]="
                    $safeNavigationMigration(toolTipList?.ADDITIONALFEEPAYABLEBYVENDOR?.COPYVALUE)
                  "
                />
                <mat-icon>file_copy</mat-icon>
              </div>
            }
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      matButton="filled"
      class="mat-accent"
      [disabled]="isspiner || AllowanceForm.hasError('dateRange')"
      (click)="saveAllowance()"
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      {{ btnTex }}
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
